/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ChannelAnalytics,
  ChannelAnalyticsParams,
  ChannelCreateRequest,
  ChannelDashboardParams,
  ChannelDashboardResponse,
  ChannelDetail,
  ChannelGenerateInsightsParams,
  ChannelInsightResponse,
  ChannelListParams,
  ChannelListRequest,
  ChannelStats,
  ChannelUpdateRequest,
  GoogleOAuthCallbackRequest,
  GoogleOAuthURL,
  PaginatedChannelListList,
  PatchedChannelListRequest,
  PatchedChannelUpdateRequest,
  YouTubeConnectRequest,
  YouTubeCredentials,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType, BodyType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 현재 사용자의 모든 YouTube 채널을 조회합니다.
 * @summary 채널 목록 조회
 */
export const channelList = (
  params?: ChannelListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedChannelListList>(
    { url: `/api/channels/`, method: "GET", params, signal },
    options,
  );
};

export const getChannelListQueryKey = (params?: ChannelListParams) => {
  return [`/api/channels/`, ...(params ? [params] : [])] as const;
};

export const getChannelListQueryOptions = <
  TData = Awaited<ReturnType<typeof channelList>>,
  TError = ErrorType<unknown>,
>(
  params?: ChannelListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof channelList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getChannelListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof channelList>>> = ({
    signal,
  }) => channelList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof channelList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChannelListQueryResult = NonNullable<
  Awaited<ReturnType<typeof channelList>>
>;
export type ChannelListQueryError = ErrorType<unknown>;

export function useChannelList<
  TData = Awaited<ReturnType<typeof channelList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ChannelListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof channelList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelList>>,
          TError,
          Awaited<ReturnType<typeof channelList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelList<
  TData = Awaited<ReturnType<typeof channelList>>,
  TError = ErrorType<unknown>,
>(
  params?: ChannelListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof channelList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelList>>,
          TError,
          Awaited<ReturnType<typeof channelList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelList<
  TData = Awaited<ReturnType<typeof channelList>>,
  TError = ErrorType<unknown>,
>(
  params?: ChannelListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof channelList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 채널 목록 조회
 */

export function useChannelList<
  TData = Awaited<ReturnType<typeof channelList>>,
  TError = ErrorType<unknown>,
>(
  params?: ChannelListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof channelList>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChannelListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 새 YouTube 채널을 등록합니다.
 * @summary 채널 생성
 */
export const channelCreate = (
  channelCreateRequest: BodyType<ChannelCreateRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChannelDetail>(
    {
      url: `/api/channels/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: channelCreateRequest,
      signal,
    },
    options,
  );
};

export const getChannelCreateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelCreate>>,
    TError,
    { data: BodyType<ChannelCreateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelCreate>>,
  TError,
  { data: BodyType<ChannelCreateRequest> },
  TContext
> => {
  const mutationKey = ["channelCreate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelCreate>>,
    { data: BodyType<ChannelCreateRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return channelCreate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof channelCreate>>
>;
export type ChannelCreateMutationBody = BodyType<ChannelCreateRequest>;
export type ChannelCreateMutationError = ErrorType<unknown>;

/**
 * @summary 채널 생성
 */
export const useChannelCreate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelCreate>>,
      TError,
      { data: BodyType<ChannelCreateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelCreate>>,
  TError,
  { data: BodyType<ChannelCreateRequest> },
  TContext
> => {
  const mutationOptions = getChannelCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 채널의 상세 정보를 조회합니다.
 * @summary 채널 상세 조회
 */
export const channelRetrieve = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChannelDetail>(
    { url: `/api/channels/${id}/`, method: "GET", signal },
    options,
  );
};

export const getChannelRetrieveQueryKey = (id?: string) => {
  return [`/api/channels/${id}/`] as const;
};

export const getChannelRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof channelRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getChannelRetrieveQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof channelRetrieve>>> = ({
    signal,
  }) => channelRetrieve(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof channelRetrieve>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChannelRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof channelRetrieve>>
>;
export type ChannelRetrieveQueryError = ErrorType<unknown>;

export function useChannelRetrieve<
  TData = Awaited<ReturnType<typeof channelRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelRetrieve>>,
          TError,
          Awaited<ReturnType<typeof channelRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelRetrieve<
  TData = Awaited<ReturnType<typeof channelRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelRetrieve>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelRetrieve>>,
          TError,
          Awaited<ReturnType<typeof channelRetrieve>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelRetrieve<
  TData = Awaited<ReturnType<typeof channelRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 채널 상세 조회
 */

export function useChannelRetrieve<
  TData = Awaited<ReturnType<typeof channelRetrieve>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelRetrieve>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChannelRetrieveQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 채널 정보를 전체 수정합니다.
 * @summary 채널 전체 수정
 */
export const channelUpdate = (
  id: string,
  channelUpdateRequest: BodyType<ChannelUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ChannelDetail>(
    {
      url: `/api/channels/${id}/`,
      method: "PUT",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: channelUpdateRequest,
    },
    options,
  );
};

export const getChannelUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelUpdate>>,
    TError,
    { id: string; data: BodyType<ChannelUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelUpdate>>,
  TError,
  { id: string; data: BodyType<ChannelUpdateRequest> },
  TContext
> => {
  const mutationKey = ["channelUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelUpdate>>,
    { id: string; data: BodyType<ChannelUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return channelUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof channelUpdate>>
>;
export type ChannelUpdateMutationBody = BodyType<ChannelUpdateRequest>;
export type ChannelUpdateMutationError = ErrorType<unknown>;

/**
 * @summary 채널 전체 수정
 */
export const useChannelUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelUpdate>>,
      TError,
      { id: string; data: BodyType<ChannelUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelUpdate>>,
  TError,
  { id: string; data: BodyType<ChannelUpdateRequest> },
  TContext
> => {
  const mutationOptions = getChannelUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 채널 정보를 부분 수정합니다.
 * @summary 채널 부분 수정
 */
export const channelPartialUpdate = (
  id: string,
  patchedChannelUpdateRequest: BodyType<PatchedChannelUpdateRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<ChannelDetail>(
    {
      url: `/api/channels/${id}/`,
      method: "PATCH",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: patchedChannelUpdateRequest,
    },
    options,
  );
};

export const getChannelPartialUpdateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelPartialUpdate>>,
    TError,
    { id: string; data: BodyType<PatchedChannelUpdateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedChannelUpdateRequest> },
  TContext
> => {
  const mutationKey = ["channelPartialUpdate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelPartialUpdate>>,
    { id: string; data: BodyType<PatchedChannelUpdateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return channelPartialUpdate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelPartialUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof channelPartialUpdate>>
>;
export type ChannelPartialUpdateMutationBody =
  BodyType<PatchedChannelUpdateRequest>;
export type ChannelPartialUpdateMutationError = ErrorType<unknown>;

/**
 * @summary 채널 부분 수정
 */
export const useChannelPartialUpdate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelPartialUpdate>>,
      TError,
      { id: string; data: BodyType<PatchedChannelUpdateRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelPartialUpdate>>,
  TError,
  { id: string; data: BodyType<PatchedChannelUpdateRequest> },
  TContext
> => {
  const mutationOptions = getChannelPartialUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 채널을 삭제합니다. (소프트 삭제)
 * @summary 채널 삭제
 */
export const channelDestroy = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<void>(
    { url: `/api/channels/${id}/`, method: "DELETE" },
    options,
  );
};

export const getChannelDestroyMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelDestroy>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["channelDestroy"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelDestroy>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return channelDestroy(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof channelDestroy>>
>;

export type ChannelDestroyMutationError = ErrorType<unknown>;

/**
 * @summary 채널 삭제
 */
export const useChannelDestroy = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelDestroy>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelDestroy>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getChannelDestroyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * VideoAnalyticsSnapshot 기반으로 조회수/좋아요 트렌드와 상위 플레이리스트를 반환합니다.
 * @summary 채널 Analytics 데이터 조회
 */
export const channelAnalytics = (
  id: string,
  params?: ChannelAnalyticsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChannelAnalytics>(
    { url: `/api/channels/${id}/analytics/`, method: "GET", params, signal },
    options,
  );
};

export const getChannelAnalyticsQueryKey = (
  id?: string,
  params?: ChannelAnalyticsParams,
) => {
  return [
    `/api/channels/${id}/analytics/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getChannelAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof channelAnalytics>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ChannelAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelAnalytics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChannelAnalyticsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof channelAnalytics>>
  > = ({ signal }) => channelAnalytics(id, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof channelAnalytics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChannelAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof channelAnalytics>>
>;
export type ChannelAnalyticsQueryError = ErrorType<unknown>;

export function useChannelAnalytics<
  TData = Awaited<ReturnType<typeof channelAnalytics>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: undefined | ChannelAnalyticsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelAnalytics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelAnalytics>>,
          TError,
          Awaited<ReturnType<typeof channelAnalytics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelAnalytics<
  TData = Awaited<ReturnType<typeof channelAnalytics>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ChannelAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelAnalytics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelAnalytics>>,
          TError,
          Awaited<ReturnType<typeof channelAnalytics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelAnalytics<
  TData = Awaited<ReturnType<typeof channelAnalytics>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ChannelAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelAnalytics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 채널 Analytics 데이터 조회
 */

export function useChannelAnalytics<
  TData = Awaited<ReturnType<typeof channelAnalytics>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ChannelAnalyticsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelAnalytics>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChannelAnalyticsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * OAuth 인증 후 YouTube 채널을 연동합니다.
 * @summary YouTube 채널 연동
 */
export const channelConnectYoutube = (
  id: string,
  youTubeConnectRequest: BodyType<YouTubeConnectRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChannelDetail>(
    {
      url: `/api/channels/${id}/connect-youtube/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: youTubeConnectRequest,
      signal,
    },
    options,
  );
};

export const getChannelConnectYoutubeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelConnectYoutube>>,
    TError,
    { id: string; data: BodyType<YouTubeConnectRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelConnectYoutube>>,
  TError,
  { id: string; data: BodyType<YouTubeConnectRequest> },
  TContext
> => {
  const mutationKey = ["channelConnectYoutube"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelConnectYoutube>>,
    { id: string; data: BodyType<YouTubeConnectRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return channelConnectYoutube(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelConnectYoutubeMutationResult = NonNullable<
  Awaited<ReturnType<typeof channelConnectYoutube>>
>;
export type ChannelConnectYoutubeMutationBody = BodyType<YouTubeConnectRequest>;
export type ChannelConnectYoutubeMutationError = ErrorType<unknown>;

/**
 * @summary YouTube 채널 연동
 */
export const useChannelConnectYoutube = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelConnectYoutube>>,
      TError,
      { id: string; data: BodyType<YouTubeConnectRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelConnectYoutube>>,
  TError,
  { id: string; data: BodyType<YouTubeConnectRequest> },
  TContext
> => {
  const mutationOptions = getChannelConnectYoutubeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * YouTube 채널 연동을 해제합니다. 인증 정보가 삭제됩니다.
 * @summary YouTube 채널 연동 해제
 */
export const channelDisconnectYoutube = (
  id: string,
  channelListRequest: BodyType<ChannelListRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChannelDetail>(
    {
      url: `/api/channels/${id}/disconnect-youtube/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: channelListRequest,
      signal,
    },
    options,
  );
};

export const getChannelDisconnectYoutubeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelDisconnectYoutube>>,
    TError,
    { id: string; data: BodyType<ChannelListRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelDisconnectYoutube>>,
  TError,
  { id: string; data: BodyType<ChannelListRequest> },
  TContext
> => {
  const mutationKey = ["channelDisconnectYoutube"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelDisconnectYoutube>>,
    { id: string; data: BodyType<ChannelListRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return channelDisconnectYoutube(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelDisconnectYoutubeMutationResult = NonNullable<
  Awaited<ReturnType<typeof channelDisconnectYoutube>>
>;
export type ChannelDisconnectYoutubeMutationBody = BodyType<ChannelListRequest>;
export type ChannelDisconnectYoutubeMutationError = ErrorType<unknown>;

/**
 * @summary YouTube 채널 연동 해제
 */
export const useChannelDisconnectYoutube = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelDisconnectYoutube>>,
      TError,
      { id: string; data: BodyType<ChannelListRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelDisconnectYoutube>>,
  TError,
  { id: string; data: BodyType<ChannelListRequest> },
  TContext
> => {
  const mutationOptions = getChannelDisconnectYoutubeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * VideoAnalyticsSnapshot 데이터를 Claude Haiku로 분석해 인사이트를 생성합니다. 24시간 캐싱.
 * @summary 채널 Analytics 인사이트 생성 (Claude Haiku)
 */
export const channelGenerateInsights = (
  id: string,
  params?: ChannelGenerateInsightsParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChannelInsightResponse>(
    {
      url: `/api/channels/${id}/generate-insights/`,
      method: "POST",
      params,
      signal,
    },
    options,
  );
};

export const getChannelGenerateInsightsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelGenerateInsights>>,
    TError,
    { id: string; params?: ChannelGenerateInsightsParams },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelGenerateInsights>>,
  TError,
  { id: string; params?: ChannelGenerateInsightsParams },
  TContext
> => {
  const mutationKey = ["channelGenerateInsights"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelGenerateInsights>>,
    { id: string; params?: ChannelGenerateInsightsParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return channelGenerateInsights(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelGenerateInsightsMutationResult = NonNullable<
  Awaited<ReturnType<typeof channelGenerateInsights>>
>;

export type ChannelGenerateInsightsMutationError = ErrorType<unknown>;

/**
 * @summary 채널 Analytics 인사이트 생성 (Claude Haiku)
 */
export const useChannelGenerateInsights = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelGenerateInsights>>,
      TError,
      { id: string; params?: ChannelGenerateInsightsParams },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelGenerateInsights>>,
  TError,
  { id: string; params?: ChannelGenerateInsightsParams },
  TContext
> => {
  const mutationOptions = getChannelGenerateInsightsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Google OAuth 인증 후 콜백을 처리하고 YouTube 채널을 연동합니다.
 * @summary Google OAuth 콜백 처리
 */
export const channelOauthCallback = (
  id: string,
  googleOAuthCallbackRequest: BodyType<GoogleOAuthCallbackRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChannelDetail>(
    {
      url: `/api/channels/${id}/oauth-callback/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: googleOAuthCallbackRequest,
      signal,
    },
    options,
  );
};

export const getChannelOauthCallbackMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelOauthCallback>>,
    TError,
    { id: string; data: BodyType<GoogleOAuthCallbackRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelOauthCallback>>,
  TError,
  { id: string; data: BodyType<GoogleOAuthCallbackRequest> },
  TContext
> => {
  const mutationKey = ["channelOauthCallback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelOauthCallback>>,
    { id: string; data: BodyType<GoogleOAuthCallbackRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return channelOauthCallback(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelOauthCallbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof channelOauthCallback>>
>;
export type ChannelOauthCallbackMutationBody =
  BodyType<GoogleOAuthCallbackRequest>;
export type ChannelOauthCallbackMutationError = ErrorType<unknown>;

/**
 * @summary Google OAuth 콜백 처리
 */
export const useChannelOauthCallback = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelOauthCallback>>,
      TError,
      { id: string; data: BodyType<GoogleOAuthCallbackRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelOauthCallback>>,
  TError,
  { id: string; data: BodyType<GoogleOAuthCallbackRequest> },
  TContext
> => {
  const mutationOptions = getChannelOauthCallbackMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 채널에 YouTube를 연동하기 위한 Google OAuth 인증 URL을 생성합니다.
 * @summary Google OAuth 인증 URL 생성
 */
export const channelOauthUrl = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<GoogleOAuthURL>(
    { url: `/api/channels/${id}/oauth-url/`, method: "GET", signal },
    options,
  );
};

export const getChannelOauthUrlQueryKey = (id?: string) => {
  return [`/api/channels/${id}/oauth-url/`] as const;
};

export const getChannelOauthUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof channelOauthUrl>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelOauthUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getChannelOauthUrlQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof channelOauthUrl>>> = ({
    signal,
  }) => channelOauthUrl(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof channelOauthUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChannelOauthUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof channelOauthUrl>>
>;
export type ChannelOauthUrlQueryError = ErrorType<unknown>;

export function useChannelOauthUrl<
  TData = Awaited<ReturnType<typeof channelOauthUrl>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelOauthUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelOauthUrl>>,
          TError,
          Awaited<ReturnType<typeof channelOauthUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelOauthUrl<
  TData = Awaited<ReturnType<typeof channelOauthUrl>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelOauthUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelOauthUrl>>,
          TError,
          Awaited<ReturnType<typeof channelOauthUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelOauthUrl<
  TData = Awaited<ReturnType<typeof channelOauthUrl>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelOauthUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Google OAuth 인증 URL 생성
 */

export function useChannelOauthUrl<
  TData = Awaited<ReturnType<typeof channelOauthUrl>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelOauthUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChannelOauthUrlQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * PR-4b: REST 멱등성 위배를 피하기 위해 GET /youtube-credentials/의 auto-refresh 기능을 분리한 POST 액션. refresh_token으로 access_token을 갱신하고 갱신된 credentials를 반환합니다.
 * @summary YouTube OAuth 토큰 강제 갱신
 */
export const channelRefreshYoutubeToken = (
  id: string,
  channelListRequest: BodyType<ChannelListRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<YouTubeCredentials>(
    {
      url: `/api/channels/${id}/refresh-youtube-token/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: channelListRequest,
      signal,
    },
    options,
  );
};

export const getChannelRefreshYoutubeTokenMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelRefreshYoutubeToken>>,
    TError,
    { id: string; data: BodyType<ChannelListRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelRefreshYoutubeToken>>,
  TError,
  { id: string; data: BodyType<ChannelListRequest> },
  TContext
> => {
  const mutationKey = ["channelRefreshYoutubeToken"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelRefreshYoutubeToken>>,
    { id: string; data: BodyType<ChannelListRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return channelRefreshYoutubeToken(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelRefreshYoutubeTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof channelRefreshYoutubeToken>>
>;
export type ChannelRefreshYoutubeTokenMutationBody =
  BodyType<ChannelListRequest>;
export type ChannelRefreshYoutubeTokenMutationError = ErrorType<unknown>;

/**
 * @summary YouTube OAuth 토큰 강제 갱신
 */
export const useChannelRefreshYoutubeToken = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelRefreshYoutubeToken>>,
      TError,
      { id: string; data: BodyType<ChannelListRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelRefreshYoutubeToken>>,
  TError,
  { id: string; data: BodyType<ChannelListRequest> },
  TContext
> => {
  const mutationOptions = getChannelRefreshYoutubeTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 해당 채널을 기본 채널로 설정합니다. 기존 기본 채널은 해제됩니다.
 * @summary 기본 채널로 설정
 */
export const channelSetDefault = (
  id: string,
  channelListRequest: BodyType<ChannelListRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChannelDetail>(
    {
      url: `/api/channels/${id}/set-default/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: channelListRequest,
      signal,
    },
    options,
  );
};

export const getChannelSetDefaultMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelSetDefault>>,
    TError,
    { id: string; data: BodyType<ChannelListRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelSetDefault>>,
  TError,
  { id: string; data: BodyType<ChannelListRequest> },
  TContext
> => {
  const mutationKey = ["channelSetDefault"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelSetDefault>>,
    { id: string; data: BodyType<ChannelListRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return channelSetDefault(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelSetDefaultMutationResult = NonNullable<
  Awaited<ReturnType<typeof channelSetDefault>>
>;
export type ChannelSetDefaultMutationBody = BodyType<ChannelListRequest>;
export type ChannelSetDefaultMutationError = ErrorType<unknown>;

/**
 * @summary 기본 채널로 설정
 */
export const useChannelSetDefault = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelSetDefault>>,
      TError,
      { id: string; data: BodyType<ChannelListRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelSetDefault>>,
  TError,
  { id: string; data: BodyType<ChannelListRequest> },
  TContext
> => {
  const mutationOptions = getChannelSetDefaultMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 채널의 플레이리스트 및 업로드 통계를 조회합니다.
 * @summary 채널 통계 조회
 */
export const channelStats = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChannelStats>(
    { url: `/api/channels/${id}/stats/`, method: "GET", signal },
    options,
  );
};

export const getChannelStatsQueryKey = (id?: string) => {
  return [`/api/channels/${id}/stats/`] as const;
};

export const getChannelStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof channelStats>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof channelStats>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getChannelStatsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof channelStats>>> = ({
    signal,
  }) => channelStats(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof channelStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChannelStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof channelStats>>
>;
export type ChannelStatsQueryError = ErrorType<unknown>;

export function useChannelStats<
  TData = Awaited<ReturnType<typeof channelStats>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof channelStats>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelStats>>,
          TError,
          Awaited<ReturnType<typeof channelStats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelStats<
  TData = Awaited<ReturnType<typeof channelStats>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof channelStats>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelStats>>,
          TError,
          Awaited<ReturnType<typeof channelStats>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelStats<
  TData = Awaited<ReturnType<typeof channelStats>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof channelStats>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 채널 통계 조회
 */

export function useChannelStats<
  TData = Awaited<ReturnType<typeof channelStats>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof channelStats>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChannelStatsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * YouTube에서 채널의 재생목록을 가져와 동기화합니다.
 * @summary YouTube 재생목록 동기화
 */
export const channelSyncYoutubePlaylists = (
  id: string,
  channelListRequest: BodyType<ChannelListRequest>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    {
      url: `/api/channels/${id}/sync-youtube-playlists/`,
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: channelListRequest,
      signal,
    },
    options,
  );
};

export const getChannelSyncYoutubePlaylistsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelSyncYoutubePlaylists>>,
    TError,
    { id: string; data: BodyType<ChannelListRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelSyncYoutubePlaylists>>,
  TError,
  { id: string; data: BodyType<ChannelListRequest> },
  TContext
> => {
  const mutationKey = ["channelSyncYoutubePlaylists"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelSyncYoutubePlaylists>>,
    { id: string; data: BodyType<ChannelListRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return channelSyncYoutubePlaylists(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelSyncYoutubePlaylistsMutationResult = NonNullable<
  Awaited<ReturnType<typeof channelSyncYoutubePlaylists>>
>;
export type ChannelSyncYoutubePlaylistsMutationBody =
  BodyType<ChannelListRequest>;
export type ChannelSyncYoutubePlaylistsMutationError = ErrorType<unknown>;

/**
 * @summary YouTube 재생목록 동기화
 */
export const useChannelSyncYoutubePlaylists = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelSyncYoutubePlaylists>>,
      TError,
      { id: string; data: BodyType<ChannelListRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelSyncYoutubePlaylists>>,
  TError,
  { id: string; data: BodyType<ChannelListRequest> },
  TContext
> => {
  const mutationOptions =
    getChannelSyncYoutubePlaylistsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * ⚠️ 보안: 응답에 OAuth refresh_token이 포함됩니다. CLI 도구의 직접 업로드 흐름에서만 사용해야 하며, 브라우저에 저장하지 마세요. PR-4b: GET은 read-only (DB write 없음). 만료 임박 시 명시적으로 POST /refresh-youtube-token/ 호출 또는 GET ?refresh=1 opt-in. P3-2: 응답에 Cache-Control: no-store 헤더로 캐시/프록시 노출 방지.
 * @summary YouTube 인증 정보 조회/갱신 (CLI 전용)
 */
export const channelYoutubeCredentials = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<YouTubeCredentials>(
    { url: `/api/channels/${id}/youtube-credentials/`, method: "GET", signal },
    options,
  );
};

export const getChannelYoutubeCredentialsQueryKey = (id?: string) => {
  return [`/api/channels/${id}/youtube-credentials/`] as const;
};

export const getChannelYoutubeCredentialsQueryOptions = <
  TData = Awaited<ReturnType<typeof channelYoutubeCredentials>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelYoutubeCredentials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChannelYoutubeCredentialsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof channelYoutubeCredentials>>
  > = ({ signal }) => channelYoutubeCredentials(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof channelYoutubeCredentials>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChannelYoutubeCredentialsQueryResult = NonNullable<
  Awaited<ReturnType<typeof channelYoutubeCredentials>>
>;
export type ChannelYoutubeCredentialsQueryError = ErrorType<unknown>;

export function useChannelYoutubeCredentials<
  TData = Awaited<ReturnType<typeof channelYoutubeCredentials>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelYoutubeCredentials>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelYoutubeCredentials>>,
          TError,
          Awaited<ReturnType<typeof channelYoutubeCredentials>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelYoutubeCredentials<
  TData = Awaited<ReturnType<typeof channelYoutubeCredentials>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelYoutubeCredentials>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelYoutubeCredentials>>,
          TError,
          Awaited<ReturnType<typeof channelYoutubeCredentials>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelYoutubeCredentials<
  TData = Awaited<ReturnType<typeof channelYoutubeCredentials>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelYoutubeCredentials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary YouTube 인증 정보 조회/갱신 (CLI 전용)
 */

export function useChannelYoutubeCredentials<
  TData = Awaited<ReturnType<typeof channelYoutubeCredentials>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelYoutubeCredentials>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChannelYoutubeCredentialsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * ⚠️ 보안: 응답에 OAuth refresh_token이 포함됩니다. CLI 도구의 직접 업로드 흐름에서만 사용해야 하며, 브라우저에 저장하지 마세요. PR-4b: GET은 read-only (DB write 없음). 만료 임박 시 명시적으로 POST /refresh-youtube-token/ 호출 또는 GET ?refresh=1 opt-in. P3-2: 응답에 Cache-Control: no-store 헤더로 캐시/프록시 노출 방지.
 * @summary YouTube 인증 정보 조회/갱신 (CLI 전용)
 */
export const channelYoutubeCredentials2 = (
  id: string,
  patchedChannelListRequest: BodyType<PatchedChannelListRequest>,
  options?: SecondParameter<typeof customInstance>,
) => {
  return customInstance<YouTubeCredentials>(
    {
      url: `/api/channels/${id}/youtube-credentials/`,
      method: "PATCH",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: patchedChannelListRequest,
    },
    options,
  );
};

export const getChannelYoutubeCredentials2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof channelYoutubeCredentials2>>,
    TError,
    { id: string; data: BodyType<PatchedChannelListRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof channelYoutubeCredentials2>>,
  TError,
  { id: string; data: BodyType<PatchedChannelListRequest> },
  TContext
> => {
  const mutationKey = ["channelYoutubeCredentials2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof channelYoutubeCredentials2>>,
    { id: string; data: BodyType<PatchedChannelListRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return channelYoutubeCredentials2(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChannelYoutubeCredentials2MutationResult = NonNullable<
  Awaited<ReturnType<typeof channelYoutubeCredentials2>>
>;
export type ChannelYoutubeCredentials2MutationBody =
  BodyType<PatchedChannelListRequest>;
export type ChannelYoutubeCredentials2MutationError = ErrorType<unknown>;

/**
 * @summary YouTube 인증 정보 조회/갱신 (CLI 전용)
 */
export const useChannelYoutubeCredentials2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof channelYoutubeCredentials2>>,
      TError,
      { id: string; data: BodyType<PatchedChannelListRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof channelYoutubeCredentials2>>,
  TError,
  { id: string; data: BodyType<PatchedChannelListRequest> },
  TContext
> => {
  const mutationOptions = getChannelYoutubeCredentials2MutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * 동기화된 YouTube 재생목록 목록을 조회합니다.
 * @summary 채널의 YouTube 재생목록 목록
 */
export const channelYoutubePlaylists = (
  id: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<void>(
    { url: `/api/channels/${id}/youtube-playlists/`, method: "GET", signal },
    options,
  );
};

export const getChannelYoutubePlaylistsQueryKey = (id?: string) => {
  return [`/api/channels/${id}/youtube-playlists/`] as const;
};

export const getChannelYoutubePlaylistsQueryOptions = <
  TData = Awaited<ReturnType<typeof channelYoutubePlaylists>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelYoutubePlaylists>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChannelYoutubePlaylistsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof channelYoutubePlaylists>>
  > = ({ signal }) => channelYoutubePlaylists(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof channelYoutubePlaylists>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChannelYoutubePlaylistsQueryResult = NonNullable<
  Awaited<ReturnType<typeof channelYoutubePlaylists>>
>;
export type ChannelYoutubePlaylistsQueryError = ErrorType<unknown>;

export function useChannelYoutubePlaylists<
  TData = Awaited<ReturnType<typeof channelYoutubePlaylists>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelYoutubePlaylists>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelYoutubePlaylists>>,
          TError,
          Awaited<ReturnType<typeof channelYoutubePlaylists>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelYoutubePlaylists<
  TData = Awaited<ReturnType<typeof channelYoutubePlaylists>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelYoutubePlaylists>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelYoutubePlaylists>>,
          TError,
          Awaited<ReturnType<typeof channelYoutubePlaylists>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelYoutubePlaylists<
  TData = Awaited<ReturnType<typeof channelYoutubePlaylists>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelYoutubePlaylists>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 채널의 YouTube 재생목록 목록
 */

export function useChannelYoutubePlaylists<
  TData = Awaited<ReturnType<typeof channelYoutubePlaylists>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelYoutubePlaylists>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChannelYoutubePlaylistsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 모든 채널의 Analytics 집계 + 비교 데이터를 반환합니다.
 * @summary 채널별 성과 대시보드
 */
export const channelDashboard = (
  params?: ChannelDashboardParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<ChannelDashboardResponse>(
    { url: `/api/channels/dashboard/`, method: "GET", params, signal },
    options,
  );
};

export const getChannelDashboardQueryKey = (
  params?: ChannelDashboardParams,
) => {
  return [`/api/channels/dashboard/`, ...(params ? [params] : [])] as const;
};

export const getChannelDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof channelDashboard>>,
  TError = ErrorType<unknown>,
>(
  params?: ChannelDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelDashboard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getChannelDashboardQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof channelDashboard>>
  > = ({ signal }) => channelDashboard(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof channelDashboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ChannelDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof channelDashboard>>
>;
export type ChannelDashboardQueryError = ErrorType<unknown>;

export function useChannelDashboard<
  TData = Awaited<ReturnType<typeof channelDashboard>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | ChannelDashboardParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelDashboard>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelDashboard>>,
          TError,
          Awaited<ReturnType<typeof channelDashboard>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelDashboard<
  TData = Awaited<ReturnType<typeof channelDashboard>>,
  TError = ErrorType<unknown>,
>(
  params?: ChannelDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelDashboard>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof channelDashboard>>,
          TError,
          Awaited<ReturnType<typeof channelDashboard>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useChannelDashboard<
  TData = Awaited<ReturnType<typeof channelDashboard>>,
  TError = ErrorType<unknown>,
>(
  params?: ChannelDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelDashboard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 채널별 성과 대시보드
 */

export function useChannelDashboard<
  TData = Awaited<ReturnType<typeof channelDashboard>>,
  TError = ErrorType<unknown>,
>(
  params?: ChannelDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof channelDashboard>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getChannelDashboardQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
